/* TT-CUSTOM 2026-11-04 Persona chip (pilot). Opens the persona flip card in a dialog from the mini card.
   Only touches elements inside [data-ttpc]. Card styles come from tt-personas.css (Personas page). */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  function init(root) {
    if (root.dataset.ttpcReady) return;
    root.dataset.ttpcReady = '1';
    const open = root.querySelector('[data-ttpc-open]');
    const lb = root.querySelector('[data-ttpc-lb]');
    if (!open) return;
    if (!lb || typeof lb.showModal !== 'function') {
      open.addEventListener('click', () => { location.href = root.dataset.href; });
      return;
    }
    const card = lb.querySelector('[data-ttpc-card]');
    const front = card.querySelector('.ttp-front'), back = card.querySelector('.ttp-back');
    new ResizeObserver(es => es.forEach(e => card.style.setProperty('--s', (e.contentRect.width / 750).toFixed(4)))).observe(card);
    let t = 0;
    const flip = (v, quiet) => {
      card.classList.toggle('is-flipped', v);
      front.inert = v; back.inert = !v;
      front.setAttribute('aria-hidden', v); back.setAttribute('aria-hidden', !v);
      back.style.visibility = v ? 'visible' : '';
      if (quiet) return;
      card.classList.add('is-flipping'); clearTimeout(t);
      t = setTimeout(() => card.classList.remove('is-flipping'), reduce.matches ? 0 : 700);
      if (v) setTimeout(() => back.querySelector('.ttp-unflip')?.focus({ preventScroll: true }), reduce.matches ? 0 : 450);
    };
    flip(false, true);
    card.addEventListener('click', e => {
      if (e.target.closest('a,.ttp-unflip')) return;
      const was = card.classList.contains('is-flipped');
      flip(!was);
      if (was) front.querySelector('.ttp-hit')?.focus({ preventScroll: true });
    });
    back.querySelector('.ttp-unflip')?.addEventListener('click', () => { flip(false); front.querySelector('.ttp-hit')?.focus({ preventScroll: true }); });
    open.addEventListener('click', () => {
      lb.querySelectorAll('img[loading="lazy"]').forEach(img => { img.loading = 'eager'; });
      flip(false, true);
      lb.showModal();
      open.setAttribute('aria-expanded', 'true');
    });
    lb.querySelector('[data-ttpc-close]')?.addEventListener('click', () => lb.close());
    lb.addEventListener('click', e => { if (e.target === lb || e.target.classList.contains('ttp-lb__wrap')) lb.close(); });
    lb.addEventListener('close', () => { open.setAttribute('aria-expanded', 'false'); open.focus({ preventScroll: true }); });
  }
  const boot = () => document.querySelectorAll('[data-ttpc]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
